export default defineNuxtRouteMiddleware(async to => {
    if (import.meta.server) return;

    const authStore = useAuthStore();

    if (
        // todo - if we attempted on the server and failed, we should not try again on the client
        !authStore.isAuthenticated
        && ((import.meta.server && useCookie('cdc_api_session').value) || import.meta.client)
    ) {
        // we may have a session cookie but not an authenticated user
        await authStore.fetch().catch(() => undefined);
    }

    if (!authStore.isAuthenticated) {
        if (to.path !== '/admin') {
            localStorage.setItem('initialTarget', JSON.stringify(to));
        }

        return navigateTo({ path: '/login' });
    }
});
